import { render } from "./OpinionScaleType.vue?vue&type=template&id=7e37cda8"
import script from "./OpinionScaleType.vue?vue&type=script&lang=js"
export * from "./OpinionScaleType.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/interfaces/interfaces/apps/flowform/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__